 import React from 'react'

const Shop = () => {
    return (
        <div className="shop">
            <div className="container">
                <div className="shop-text">
                    <div>
                        <h1>Free Delivery With PIZZA OF THE DAY Only 8.99 USD</h1>
                        <div className="shop-btn">
                            <a href="#" className="btn btn-smart">SHOP NOW</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Shop
